/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MatCarouselSlideComponent as ɵh} from './lib/mat-carousel/carousel-slide/carousel-slide.component';
export {MatCarouselComponent as ɵg} from './lib/mat-carousel/carousel.component';
export {MatCarouselHammerConfig as ɵe,MatCarouselModule as ɵf} from './lib/mat-carousel/carousel.module';
export {MxSlideEditComponent as ɵd} from './lib/mx-slide-edit/mx-slide-edit.component';
export {MxSliderConfigComponent as ɵb} from './lib/mx-slider-config/mx-slider-config.component';
export {MxSliderCrudComponent as ɵc} from './lib/mx-slider-crud/mx-slider-crud.component';
export {MxSliderComponent as ɵa} from './lib/mx-slider/mx-slider.component';
export {FirebaseModule as ɵi} from './shared/firebase.module';
export {MaterialModule as ɵj} from './shared/material.module';